export default __webpack_public_path__ + "static/media/0.c85d2b91.jpg";